import React, {Component} from 'react';
import InputValidationError from "../common/InputValidationError";

export default class CustomerDetails extends Component {
    render() {
        const {onChange, first_name, last_name, email, phone, errors} = this.props;
        return (
            <div>
                <div className='pb-5'>
                    <div className="row justify-content-center py-3">
                        <h2 className="wizard-heading">Enter your details</h2>
                    </div>
                    <div className="row justify-content-center ">
                        <div className="col-md-10 justify-content-center">
                            <div className="card ">
                                <div className="card-body card-wizard">
                                    <div className="form-group row">
                                        <div className="col-md-2">
                                            <label className='wizard-label'>
                                                <small>First name <i
                                                    className='fa fa-asterisk'> </i></small>
                                            </label>
                                        </div>
                                        <div className="col-md-10">
                                            <input type="text"
                                                   name='first_name'
                                                   className='form-control'
                                                   onChange={(e) => onChange(e)}
                                                   value={first_name}
                                                   placeholder='Enter first name...'
                                            />
                                            <InputValidationError error={errors.first_name}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-md-2">
                                            <label className='wizard-label'>
                                                <small>Last name <i className='fa fa-asterisk'> </i></small>
                                            </label>
                                        </div>
                                        <div className="col-md-10">
                                            <input type="text"
                                                   name='last_name'
                                                   className='form-control'
                                                   onChange={(e) => onChange(e)}
                                                   value={last_name}
                                                   placeholder='Enter last name...'
                                            />
                                            <InputValidationError error={errors.last_name}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-md-2">
                                            <label className='wizard-label'>
                                                <small>Email <i className='fa fa-asterisk'> </i></small>
                                            </label>
                                        </div>
                                        <div className="col-md-10">
                                            <input type="text"
                                                   name='email'
                                                   className='form-control'
                                                   onChange={(e) => onChange(e)}
                                                   value={email}
                                                   placeholder='Enter your email...'
                                            />
                                            <InputValidationError error={errors.email}/>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-md-2">
                                            <label className='wizard-label'>
                                                <small>Phone <i className='fa fa-asterisk'> </i></small>
                                            </label>
                                        </div>
                                        <div className="col-md-10">
                                            <input type="text"
                                                   name='phone'
                                                   className='form-control'
                                                   value={phone}
                                                   onChange={(e) => onChange(e)}
                                                   placeholder='Enter your phone...'
                                            />
                                            <InputValidationError error={errors.phone}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
